module.exports = __webpack_public_path__ + "static/media/logo.e21f7e04.svg";